import { debounce } from 'lodash'

// sub 인스턴스마다 따로 쓰는 자동저장 debounce.
// methods 에 debounce 를 두면 모든 sub 가 타이머 하나를 공유해 마지막 호출만 저장된다.
// 저장 대상(scope)은 입력 시점에 캡처한다 — 언마운트 flush 때는 $route 가 이미 바뀌어 있을 수 있다.
export function createDebouncedSave (vm, wait = 800) {
    const run = debounce((update_pipeline, options, scope) => {
        vm.$nextTick(async () => {
            await vm.dbSave(update_pipeline, options, scope)
        })
    }, wait)
    const save = (update_pipeline = false, options = {}) => run(update_pipeline, options, vm.getSaveScope())
    save.flush = () => run.flush()
    save.cancel = () => run.cancel()
    return save
}
